import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { ICommonEvent, ITableEvent, ITableSearchState } from '../shared/interfaces/ITable';

@Injectable({
  providedIn: 'root'
})
export class TableService {
  tableSubject = new Subject<ITableEvent>();
  tabObservable = this.tableSubject.asObservable();

  tableToggleExpandSubject = new Subject<ICommonEvent>();
  tableToggleExpandObservable$ = this.tableToggleExpandSubject.asObservable();

  private readonly searchStates = new Map<string, ITableSearchState>();

  saveSearchState(tableId: string, state: Omit<ITableSearchState, 'shouldRestore'>): void {
    const currentState = this.getOrCreateSearchState(tableId);
    this.searchStates.set(tableId, {
      ...state,
      globalSearch: { ...state.globalSearch },
      filterText: { ...state.filterText },
      columnFilterText: { ...state.columnFilterText },
      columnFilterOperator: { ...state.columnFilterOperator },
      customColumnFilters: { ...state.customColumnFilters },
      customColumnFilterValues: { ...state.customColumnFilterValues },
      shouldRestore: currentState.shouldRestore
    });
  }

  markForRestore(tableId: string): void {
    this.getOrCreateSearchState(tableId).shouldRestore = true;
  }

  consumeSearchState(tableId: string): ITableSearchState | null {
    const state = this.searchStates.get(tableId);
    if (!state?.shouldRestore) return null;

    state.shouldRestore = false;
    return {
      ...state,
      globalSearch: { ...state.globalSearch },
      filterText: { ...state.filterText },
      columnFilterText: { ...state.columnFilterText },
      columnFilterOperator: { ...state.columnFilterOperator },
      customColumnFilters: { ...state.customColumnFilters },
      customColumnFilterValues: { ...state.customColumnFilterValues }
    };
  }

  clearSearchState(tableId: string): void {
    this.searchStates.delete(tableId);
  }

  private getOrCreateSearchState(tableId: string): ITableSearchState {
    let state = this.searchStates.get(tableId);
    if (!state) {
      state = {
        globalSearchValue: '',
        globalSearch: {},
        filterText: {},
        columnFilterText: {},
        columnFilterOperator: {},
        customColumnFilters: {},
        customColumnFilterValues: {},
        shouldRestore: false
      };
      this.searchStates.set(tableId, state);
    }
    return state;
  }
}
